
export class ComponentCount {
  constructor(
          public period?: string,
          public yesCount?: number,
          public noCount?: number,
          public gnCount?: number,
          public ggCount?: number,
          public metPlanCd?: any,
      ) {
      }
  }



// WEBPACK FOOTER //
// ./src/app/shared/model/ComponentCount.model.ts